import ProductScroller from "../../../common/productscrollers.js";

class WaitToLoad {
    constructor(){
        this.options = null;
        this.relatedDiv = document.getElementById('dealOfTheDayBanner');
        this.newestScrollerDiv = document.getElementById('newestScroller');

        this.observer = new IntersectionObserver(this.callBack.bind(this), this.options);
    }

    init() {
        if (this.relatedDiv) {
            this.options = { root: this.relatedDiv, threshold: 1.0 };
            this.observer.observe(this.relatedDiv);
        }

        if (this.newestScrollerDiv) {
            this.options = { root: this.newestScrollerDiv, threshold: 1.0 };
            this.observer.observe(this.newestScrollerDiv);
        }
    }

    callBack(entries, observer) {
        entries.forEach(async (entry) => {
            if (entry.intersectionRatio > 0) {
                if (entry.target === this.relatedDiv) {
                    this.relatedDiv.innerHTML = await this.getCurrentDOTD();
                    this.observer.unobserve(this.relatedDiv);
                }
                if (entry.target === this.newestScrollerDiv) {
                    this.newestScrollerDiv.innerHTML = await this.getNewestScroller();
                    const newestScroller = new ProductScroller();
                    newestScroller.init("newestScroller", 5, 3, 2);
                    this.observer.unobserve(this.newestScrollerDiv);
                }
            }
        });
    }
    
    async getNewestScroller() {
        try{
            const response = await fetch('/home/newestitemsscroller', {
                method: 'GET', 
                headers: { 'X-Requested-With': 'fetch' }
            });
            //if(!response.ok) throw new Error(`Error processing request: ${response.statusText}`);
            const responseHTML = await response.text();
            if (responseHTML.length < 1) return "";
            return responseHTML;
        }catch(error){
            console.error(error);
            return "";
        }
    }

    async getCurrentDOTD() {
        try{
            const response = await fetch('/home/dealofthedaybanner', {
                method: 'GET', 
                headers: { 'X-Requested-With': 'fetch' }
            });
            //if(!response.ok) throw new Error(`Error processing request: ${response.statusText}`);
            const responseHTML = await response.text();
            if (responseHTML.length < 1) return "";
            return responseHTML;
        }catch(error){
            console.error(error);
            return "";
        }
    }
}

export default new WaitToLoad();